module.exports = __webpack_public_path__ + "static/ms-icon-144x144-4bb315c5a205b8c89a9c44d0c6925161.png";